/**
 * useStore composable
 * Vuexストアへのアクセスを提供
 */
import { getCurrentInstance } from '@vue/composition-api'

export function useStore() {
  const vm = getCurrentInstance()
  if (!vm) {
    throw new Error('useStore must be called from within a setup function')
  }

  return vm.proxy.$store
}

export default useStore
